import { gql } from "graphql-tag";
import { responseField } from "../../../base.graphql";
import {paginationFields} from "../geographical-zone/geographical-zone.graphql";

const alertDashboardFields = `
createdAt
id
status
totalAlerts
uniqueId
`;

const dashboardCountsFields = `
totalBins
totalSensors
totalWarehouses
totalZones
warehousePerRegion {
    region
    warehouseCount
}
`;

//MUTATIONS
export const UPDATE_ALERT_DASHBOARD_MUTATION = gql`
    mutation UpdateAlertDashboardData($input: AlertDashboardInput!) {
        updateAlertDashboardData(input: $input) {
            response {
                ${responseField}
            }
            data {
                ${alertDashboardFields}
            }
        }
    }
`;

//QUERIES
export const GET_ALERT_DASHBOARD_DATA_QUERY = gql`
    query GetAlertDashboardData($filtering: AlertDashboardFilteringInputObject!) {
        getAlertDashboardData(filtering: $filtering) {
            response {
                ${responseField}
            }
            data {
                ${alertDashboardFields}
            }
            page {
                ${paginationFields}
            }
        }
    }
`;

export const GET_DASHBOARD_COUNTS_QUERY = gql`
    query GetDashboardCounts {
        getDashboardCounts {
            response {
                ${responseField}
            }
            data {
                ${dashboardCountsFields}
            }
        }
    }
`;
export const GET_MAIN_DASHBOARD_DATA = gql`
    query getMainDashboardData ($filtering: DashboardFilteringInputbjects){
        getMainDashboardData (filtering: $filtering){
            data {
                dashboardData
            }
        }
    }
`;

export const GET_SENSOR_BY_WAREHOUSE_COUNT_DATA = gql`
    query getSensorByWarehouseCount{
        getSensorByWarehouseCount{
        response{
        ${responseField}
        }
            data {
             sensorsInstalled
      sensorByWarehouse {
        warehouseUniqueId
        warehouseName
        numberOfSensors
        activeSensors
        inactiveSensors
      }
            }
        }
    }
`;
export const GET_ALERT_DASHBOARD_DATA = 
gql`
  query GetSensorAlertData($filtering: SensorAlertDataFilteringObject) {
  getSensorAlertData(filtering: $filtering) {
    data {
      createdAt
      id
      warehouseName
      alertType
      reading
    }
   
    response {
      id
      status
      code
      message
    }
  }
}
`;
